/* eslint-disable max-len */
export const CashbackDetails = "/cashback";
export const GoShopModalApp = { url: "/cashback/goToStore/%7BbrandId%7D/%7BappUserId%7D", type: undefined as { brandId: string | number; appUserId?: string | number; } };
export const CashbackDetailsTemporaryListFullPage = "/cashback/custom/claim";
export const MobileLandingPage = "/czymjestcashback";
export const Cashback = { url: "/api/cashback/%7Baction%7D", type: undefined as { action: string | number; } };
